import React, { FC, useCallback, useMemo } from 'react';
import styles from './index.module.scss';
import { getSVG } from '@/components/Common/styles/mixins';
import clsx from 'clsx';

const BenefitCards: FC = () => {
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/${path}`), []);
  const [cardTitle] = useMemo(() => ['v8/nol_card.svg'].map(getResourcePath), []);
  return (
    <>
      <div className={styles.cardSectionWrapperTop} />
      <div className={styles.cardSectionWrapper}>
        <section className={styles.cardSection}>
          <div className={styles.cardHeader}>
            <img src={cardTitle} alt={'nol 카드'} />
            <h3>이벤트</h3>
          </div>
          <ul>
            {EVENT_BENEFITS.map((card) => (
              <CardItem {...card} key={card.icon} />
            ))}
          </ul>
        </section>
        <section className={styles.cardSection}>
          <div className={styles.cardHeader}>
            <img src={cardTitle} alt={'nol 카드'} />
            <h3>혜택</h3>
          </div>
          <ul>
            {BASE_BENEFITS.map((card) => (
              <CardItem {...card} key={card.icon} />
            ))}
          </ul>
        </section>
      </div>
    </>
  );
};
export default BenefitCards;

interface CardItemTitle {
  type: 'blue' | 'normal';
  value: string;
  size?: 'small';
}

interface CardItemProps {
  subTitle: string;
  title: CardItemTitle[];
  icon: string;
  alt: string;
}

const CardItem: FC<CardItemProps> = ({ subTitle, title, icon, alt }) => {
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/${path}`), []);

  return (
    <li className={styles.cardItem}>
      <img className={styles.cardIcon} src={getResourcePath(icon)} alt={alt} />
      <div className={styles.cardTitleWrapper}>
        <p className={styles.cardSubTitle}>{subTitle}</p>
        <p className={styles.cardTitle}>
          {title.map((item, index) => (
            <span
              key={index}
              className={clsx(
                item.type === 'blue' ? styles.cardTitleBlue : '',
                item.size === 'small' ? styles.cardTitleSmall : '',
              )}
            >
              {item.value}
            </span>
          ))}
        </p>
      </div>
    </li>
  );
};

const EVENT_BENEFITS: CardItemProps[] = [
  {
    alt: 'NOL 쿠폰 아이콘',
    icon: 'v9/v28_icon_keyvisual_02.png',
    subTitle: 'NOL 전용 웰컴 쿠폰',
    title: [
      { type: 'blue', value: '50% 할인' },
      { type: 'normal', value: ' X 5장 (최대 16.5만원)' },
    ],
  },
  {
    alt: 'NOL 첫결제 캐시백',
    icon: 'v9/v27_icon_keyvisual_01.png',
    subTitle: 'NOL 카드로 NOL에서 첫 결제 시',
    title: [
      { type: 'blue', value: '2만원' },
      { type: 'normal', value: ' 캐시백' },
    ],
  },
  {
    alt: '선지급 포인트 서비스',
    icon: 'v9/v23_icon_keyvisual_02.png',
    subTitle: '선지급 포인트 서비스',
    title: [
      { type: 'blue', value: '최대 30만' },
      { type: 'normal', value: ' NOL 포인트 긴급적립' },
    ],
  },
  {
    // 2024-04-01 로밍패스 심의 미통과로 임시 미노출
    alt: '로밍패스 아이콘',
    icon: 'v7/v7_icon_keyvisual_roaming_pass.png',
    subTitle: 'NOL 카드 회원 로밍패스2 혜택',
    title: [
      { type: 'normal', value: '로밍패스2 1년 ' },
      { type: 'blue', value: '가입비 0원' },
    ],
  },
];
const BASE_BENEFITS: CardItemProps[] = [
  {
    alt: '포인트 아이콘',
    icon: 'v8/v7_icon_keyvisual_04.png',
    subTitle: 'NOL 포인트',
    title: [
      { type: 'blue', value: '10%' },
      { type: 'normal', value: ' 적립 (월 최대 3.6만P)' },
    ],
  },
  {
    alt: 'VISA/AMEX 혜택',
    icon: 'v7/icon_flight.png',
    subTitle: 'Visa/Amex 혜택',
    title: [
      { type: 'normal', value: '공항 라운지 ' },
      { type: 'blue', value: '연 2회 무료' },
    ],
  },
];
